import { useEffect, useState } from 'react';
import {
  DEFAULT_SHARE_CARD_TEMPLATES,
  type ShareCardTemplates,
} from '@shared/shareCards/shareCardTemplates';
import { fetchShareCardTemplates } from '@shared/services/shareCardTemplatesService';

let cached: ShareCardTemplates | null = null;
let inflight: Promise<ShareCardTemplates> | null = null;

/**
 * Share-card templates: code defaults immediately, admin overrides from the
 * shareCardTemplates collection once fetched (cached for the session).
 * Pass `enabled: false` (flag off) to skip the fetch entirely.
 */
export function useShareCardTemplates(enabled: boolean): ShareCardTemplates {
  const [templates, setTemplates] = useState<ShareCardTemplates>(
    cached ?? DEFAULT_SHARE_CARD_TEMPLATES
  );

  useEffect(() => {
    if (!enabled || cached) return;
    let mounted = true;
    inflight ??= fetchShareCardTemplates();
    inflight.then((merged) => {
      cached = merged;
      if (mounted) setTemplates(merged);
    });
    return () => {
      mounted = false;
    };
  }, [enabled]);

  return templates;
}
